import React from 'react';
import { CategoryList } from './CategoryList';

interface CategoryManagementProps {
  className?: string;
  isAdmin?: boolean;
}

export const CategoryManagement: React.FC<CategoryManagementProps> = ({
  className = '',
  isAdmin = false
}) => {
  return (
    <div className={`container mx-auto p-6 ${className}`}>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Category Management</h1>
          <p className="text-muted-foreground mt-1">
            Organize your prompts with categories. You can create, edit, and manage categories here.
          </p>
        </div>

        <CategoryList showActions={true} isAdmin={isAdmin} />
      </div>
    </div>
  );
};